import { RECEIVE_TFR_TEMPLATES, REMOVE_TFR_TEMPLATE } from './actions';

const initialState = {
  tfrTemplates: [],
};

// eslint-disable-next-line default-param-last
export function reducer(state = initialState, action) {
  switch (action.type) {
    case RECEIVE_TFR_TEMPLATES: {
      return {
        ...state,
        tfrTemplates: action.tfrTemplates,
      };
    }
    case REMOVE_TFR_TEMPLATE: {
      const templateIdx = state.tfrTemplates.findIndex(
        (template) => template.id === action.templateId
      );
      if (templateIdx >= 0) {
        return {
          ...state,
          tfrTemplates: [
            ...state.tfrTemplates.slice(0, templateIdx),
            ...state.tfrTemplates.slice(templateIdx + 1),
          ],
        };
      }
      return state;
    }
    default:
      return state;
  }
}

export default reducer;
